import SignupPage from 'pages/SignUp';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const HomeRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/restaurant-home-page');
    }
   
  }, [navigate]);

 
  const token = localStorage.getItem('token');
  if (!token) {
    return <SignupPage />;
  }

  
  return null;
};

export default HomeRedirect;